export const VARIANTS = [
  {
    key: "open",
    label: "Anyone can join",
    description: "Public. Members join instantly.",
    visibility: "public" as const,
    join_policy: "open" as const,
    searchable: true,
  },
  {
    key: "approval",
    label: "Approval needed",
    description: "Public. You approve each new member.",
    visibility: "public" as const,
    join_policy: "approval" as const,
    searchable: true,
  },
  {
    key: "private_searchable",
    label: "Searchable, approval needed",
    description: "Private. Found by name only; you approve joins.",
    visibility: "private" as const,
    join_policy: "approval" as const,
    searchable: true,
  },
  {
    key: "hidden",
    label: "Hidden — invite only",
    description: "Private. Never shown in search; join by link.",
    visibility: "private" as const,
    join_policy: "invite_only" as const,
    searchable: false,
  },
] as const;
